import { request } from "services/api/util";

class ReferralCampaignService {
  getHeaders() {
    return {
      "Accept-Language": "th",
      "content-type": "application/json;charset=UTF-8",
    };
  }

  async getListReferralCampaigns(params) {
    const config = {
      method: "get",
      url: `v1/admin/referralCampaigns`,
      params: params,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getReferralCampaignDetail(id) {
    const config = {
      method: "get",
      url: `v1/admin/referralCampaigns/${id}`,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async createReferralCampaign(body) {
    const config = {
      method: "post",
      url: `v1/admin/referralCampaigns`,
      data: body,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async updateReferralCampaign(body, id) {
    const config = {
      method: "put",
      url: `v1/admin/referralCampaigns/${id}`,
      data: body,
      headers: this.getHeaders(),
    };
    return request(config);
  }
}

export default new ReferralCampaignService();
